import React from "react";
const OverlaysContext = React.createContext({});
OverlaysContext.displayName = "OverlaysContext";
export default OverlaysContext;
